import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const Tooltip = ({ content, position, hovered }) => {
    const tooltipRef = useRef(null);
    // const lastPositionRef = useRef(null);

    useEffect(() => {
        const tooltip = d3.select(tooltipRef.current);

        tooltip
            .style('left', '-9999px')
            .style('top', '-9999px')
            .style('display', 'block')
            .style('min-width', '80px');
        
        const adjustPosition = (pos) => {
            const tooltipNode = tooltip.node();
            const { width: tooltipWidth } = tooltipNode.getBoundingClientRect();
            const { innerWidth: windowWidth } = window;

            let x = pos.x;
            let y = pos.y;

            if (x + tooltipWidth > windowWidth ) {
                x = windowWidth - tooltipWidth - 10;
            }

            return { x, y };
        };

        const adjustedPosition = adjustPosition(position);
        // lastPositionRef.current = adjustedPosition;
        
        tooltip
            .style('display', content ? 'block' : 'none')
            .html(content)
            .style('left', `${adjustedPosition.x}px`)
            .style('top', `${adjustedPosition.y}px`);
            // .style('background-color', 'white');

        if (hovered) {
            const element = d3.select(hovered);
            // const parentGroup = d3.select(element.node().parentNode);
            const parentNode = element.node() && element.node().parentNode;

            // // Move the entire group to the top
            // parentGroup.node().parentNode.appendChild(parentGroup.node());

            // element
            //     .attr('original-stroke', element.style('stroke'))
            //     .attr('original-stroke-width', element.style('stroke-width'));

            // element
            //     .style('stroke', 'white')
            //     .style('stroke-opacity', '0.8')
            //     .style('stroke-width', '2px');
            if (parentNode) {
                const parentGroup = d3.select(parentNode);

                // Move the entire group to the top
                if (parentGroup) {
                    const grandParentNode = parentGroup.node().parentNode;
                    if (grandParentNode) {
                        grandParentNode.appendChild(parentGroup.node());
                    }

                    element
                        .attr('original-stroke', element.style('stroke'))
                        .attr('original-stroke-width', element.style('stroke-width'));

                    element
                        .style('stroke', 'white')
                        .style('stroke-opacity', '0.8')
                        .style('stroke-width', '2px');
                }
            }
        }

        return () => {
            if (hovered) {
                const element = d3.select(hovered);

                // Check if the element is still valid
                if (element.node()) {
                    element
                        .style('stroke', element.attr('original-stroke'))
                        .style('stroke-width', element.attr('original-stroke-width'));

                    element
                        .attr('original-stroke', null)
                        .attr('original-stroke-width', null);
                }
                console.log(`hoverd  x=${adjustedPosition.x}, y=${adjustedPosition.y}` );
            }
        };
        
    }, [content, position, hovered]);
    return (
        <div ref={tooltipRef} className="tooltip"></div>
    );
};

export default Tooltip;
